import { render, staticRenderFns } from "./PromoCode.vue?vue&type=template&id=71860ba9&scoped=true&"
import script from "./PromoCode.vue?vue&type=script&lang=ts&"
export * from "./PromoCode.vue?vue&type=script&lang=ts&"
import style0 from "./PromoCode.vue?vue&type=style&index=0&id=71860ba9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71860ba9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMain } from 'vuetify/lib/components/VMain';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VForm,VMain,VProgressCircular,VTextField})
